/**
 * CATALOGUE CONSTANTS + FILTER/SORT HELPERS
 * ---------------------------------------------------------------
 * Product data now lives in MongoDB and is managed via the Admin Dashboard
 * (Products + Collections screens). This file only holds the shared
 * dropdown options and the filter/sort helper functions that both the
 * public collection page and the admin filters draw from.
 */

export const RECIPIENTS = [
  { value: "employees", label: "Employees" },
  { value: "clients", label: "Clients" },
  { value: "leadership", label: "Leadership" },
  { value: "channel-partners", label: "Channel Partners" },
  { value: "dealers", label: "Dealers" },
  { value: "vip", label: "VIP" },
];

export const AVAILABILITY = [
  { value: "ready-to-dispatch", label: "Ready to Dispatch" },
  { value: "made-to-order", label: "Made to Order" },
];

export const BUDGETS = [
  { value: "500-1000", label: "₹500 – ₹1,000", min: 500, max: 1000 },
  { value: "1000-1500", label: "₹1,000 – ₹1,500", min: 1000, max: 1500 },
  { value: "1500-2000", label: "₹1,500 – ₹2,000", min: 1500, max: 2000 },
  { value: "2000-2500", label: "₹2,000 – ₹2,500", min: 2000, max: 2500 },
  { value: "2500-3000", label: "₹2,500 – ₹3,000", min: 2500, max: 3000 },
  { value: "3000+", label: "₹3,000+", min: 3000, max: Infinity },
];

export const SORTS = [
  { value: "featured", label: "Featured" },
  { value: "popular", label: "Most Popular" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
];

export const BADGES = [
  "None",
  "Best Seller",
  "Featured",
  "Premium",
  "Luxury Choice",
  "Most Popular",
  "New Launch",
  "Limited Edition",
  "New",
  "Sustainable",
];

export function budgetMatches(product, budgetValue) {
  if (!budgetValue) return true;
  const b = BUDGETS.find((x) => x.value === budgetValue);
  if (!b) return true;
  return product.price >= b.min && product.price <= b.max;
}

export function recipientMatches(product, recipientValue) {
  if (!recipientValue) return true;
  return Array.isArray(product.recipient) && product.recipient.includes(recipientValue);
}

export function availabilityMatches(product, availValue) {
  if (!availValue) return true;
  return product.availability === availValue;
}

export function sortProducts(list, sortValue) {
  const arr = [...list];
  switch (sortValue) {
    case "price-asc":
      arr.sort((a, b) => a.price - b.price); break;
    case "price-desc":
      arr.sort((a, b) => b.price - a.price); break;
    case "popular":
      arr.sort((a, b) => (b.popularity || 0) - (a.popularity || 0)); break;
    case "featured":
    default:
      arr.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0) || (b.popularity || 0) - (a.popularity || 0));
  }
  return arr;
}
